import 'url-search-params-polyfill';

import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { initSentryIdle } from '@utils/sentry/initSentryBrowser';
import apolloWrapper from '@hoc/apolloWrapper';
import {
  getClientLocale,
  I18NProvider,
} from '@utils/i18n';
import {
  AppContext,
  defaultValue as appContextDefaultValue,
} from '@contexts/AppContext';
import { getIsOutletByHost } from '@utils/common';

import BaseApp from './BaseApp';

// constants
const appElement = document.querySelector('#app');

initSentryIdle();

const ApolloApp = apolloWrapper(BaseApp);

if (appElement) {
  const isOutlet = getIsOutletByHost(window.location.host);

  const { lang, routerBasename } = getClientLocale();
  const root = createRoot(appElement);

  root.render(
    <AppContext.Provider
      value={{
        ...appContextDefaultValue,
        isOutlet,
      }}
    >
      <HelmetProvider>
        <BrowserRouter basename={routerBasename}>
          <I18NProvider lang={lang}>
            {
              () => <ApolloApp />
            }
          </I18NProvider>
        </BrowserRouter>
      </HelmetProvider>
    </AppContext.Provider>,
  );
}

if (module.hot) {
  module.hot.accept();
}

if (__DEV__) {
  loadDevMessages();
  loadErrorMessages();
}
